<template>
  <div class="angebot-view">
    <div class="angebot-grid">
      <main class="angebot-main">
        <KeinAntrag
          v-if="!showDoppelantrag && !tarif && berechnung"
          :tarif="tarif"
          :berechnung="berechnung"
        />
        <DoppelAntrag :tarif="tarif" v-if="showDoppelantrag && tarif" />

        <AntragStep1Header
          :tarif="tarif"
          :berechnung="berechnung"
          v-if="tarif"
        />

        <PreisSprung
          class="my-4"
          v-if="!showDoppelantrag && tarif && tarif.preissprungProzent1 > 0"
          :tarif="tarif"
          :componentKeyStatus="componentKeyStatus"
        />

        <ClearmentAuswahl
          v-if="tarif && berechnung.ber_segment <= 1"
          @updatedClearment="handleClearment"
          :tarif="tarif"
          :berechnung="berechnung"
          :componentKeyStatus="componentKeyStatus"
        />

        <SofortVersichert
          v-if="
            !showDoppelantrag &&
            tarif &&
            tarif.tarif_sofort > 0 &&
            berechnung.ber_sofort == 1
          "
          @updatedMitversicherungSofort="handleMitversicherungSofort"
          :tarif="tarif"
          :berechnung="berechnung"
          :componentKeyStatus="componentKeyStatus"
        />

        <antragfragen-form
          v-if="!showDoppelantrag"
          :token="route.params.token"
          :tarif_id="route.params.tarif_id"
          :componentKeyStatus="componentKeyStatus"
          @updatedTarif="handleTarifUpdate"
          @updateAntrag="handleAntragUpdate"
          @updateBerechnung="handleBerechnungUpdate"
        />

        <v-alert
          v-if="showErrorHinweis && antragButtonClicked"
          type="error"
          variant="tonal"
          density="comfortable"
          class="ang-alert my-3"
        >
          <strong>Bitte überprüfen Sie Ihre Angaben.</strong>
          Bitte prüfen Sie die <b>rot-markierten</b> Felder.
        </v-alert>

        <div v-if="!showDoppelantrag && tarif" class="ang-submit">
          <div v-if="antragSubmited" class="ang-submit__loading">
            <v-progress-circular :size="44" color="primary" indeterminate />
            <h2 class="ang-submit__loading-text">
              Bitte haben Sie noch ein wenig Geduld …
            </h2>
          </div>

          <v-btn
            v-if="!antragSubmited"
            @click="submitAntragStep1"
            color="primary"
            variant="flat"
            rounded="0"
            block
            size="large"
            class="ang-submit__btn"
          >
            <v-icon icon="mdi-arrow-right-circle" size="20" class="mr-2" />
            <span v-if="sharedDataStore.isMobile()">weiter zu Schritt 2</span>
            <span v-else>jetzt weiter zu Schritt 2 von 2</span>
          </v-btn>

          <Antrag1Button v-if="!sharedDataStore.isMobile() && tarif" />
        </div>
      </main>

      <aside class="angebot-aside" v-if="!sharedDataStore.isMobile()">
        <InfopaketHinweise v-if="tarif" />
      </aside>
    </div>
  </div>
</template>

<script setup>
  import { watch, ref, onMounted, getCurrentInstance } from "vue";
  import { useRoute, useRouter } from "vue-router";
  import AntragfragenForm from "@/components/berechnung/form/AntragfragenForm";
  import DoppelAntrag from "@/components/berechnung/form/info/DoppelAntrag";
  import InfopaketHinweise from "@/components/berechnung/info/InfopaketHinweise";
  import SofortVersichert from "@/components/berechnung/form/info/SofortVersichert";
  import ClearmentAuswahl from "@/components/berechnung/form/info/ClearmentAuswahl";
  import KeinAntrag from "@/components/berechnung/form/KeinAntrag";
  import AntragStep1Header from "@/components/berechnung/form/AntragStep1Header";
  import PreisSprung from "@/components/tarif/info/PreisSprung";
  import Antrag1Button from "@/components/sales/Antrag1Button";
  import { useSharedDataStore } from "@/stores/sharedData";
  import { useLoaderStore } from "@/stores/loaderStore";
  import { useErrorStore } from "@/stores/errorStore";
  import BaseCalls from "@/services/BaseCalls";
  import { useBerechnungStore } from "@/stores/berechnung";
  const berechnungStore = useBerechnungStore();
  const errorStore = useErrorStore();
  const { proxy } = getCurrentInstance();
  const loaderStore = useLoaderStore();
  const sharedDataStore = useSharedDataStore();
  const route = useRoute();
  const router = useRouter();
  const componentKeyStatus = ref(0);
  const tarif = ref(false);
  const antragfragen = ref(false);
  const berechnung = ref(false);
  const antragSubmited = ref(false);
  const antragButtonClicked = ref(false);
  const showDoppelantrag = ref(false);
  const mitVersicherungSofort = ref(false);
  const mitClearment = ref(true);
  const showErrorHinweis = ref(false);

  function handleTarifUpdate(data) {
    tarif.value = data;
  }

  function handleAntragUpdate(data) {
    antragfragen.value = data;
  }
  function handleBerechnungUpdate(data) {
    berechnung.value = data;
    if (berechnung.value.ber_kunden_id > 0) {
      showDoppelantrag.value = true;
    }
  }
  function handleMitversicherungSofort(data) {
    mitVersicherungSofort.value = data;
  }
  function handleClearment(data) {
    mitClearment.value = data;
  }

  function setLoading(loading) {
    loaderStore.setLoader(loading);
  }
  const checkAntragOk = () => {
    if (Array.isArray(antragfragen.value)) {
      return !antragfragen.value.some((frage) => frage.showFrageError);
    }
    return true;
  };

  async function submitAntragStep1() {
    antragButtonClicked.value = true;
    if (!checkAntragOk()) {
      showErrorHinweis.value = true;
      return false;
    }
    showErrorHinweis.value = false;
    antragSubmited.value = true;
    let select = {};
    select.action = "checkAntragStep1Formular";
    select.antragfragen = antragfragen.value;
    select.ber_identity_token = berechnung.value.ber_identity_token;
    select.ber_alter = berechnung.value.ber_alter;
    select.tarif_id = tarif.value.tarif_id;
    select.mitClearment = mitClearment.value;
    select.mitVersicherungSofort = mitVersicherungSofort.value;
    setLoading(true);
    try {
      const resp = await BaseCalls.postTarif(select);
      if (resp.data && resp.data.success) {
        router.push(
          "/angebot/kostenlos_fertig/" +
            tarif.value.tarif_id +
            "/" +
            berechnung.value.ber_identity_token
        );
      } else {
        antragSubmited.value = false;
        setLoading(false);
        errorStore.setError(true, "Dieser Tarif ist nicht beantragbar.");
      }
    } catch (err) {
      antragSubmited.value = false;
      console.log("error berechnung");
    }
  }
  onMounted(() => {
    berechnungStore.setShowFooter(false);
    setLoading(true);
    proxy.$updateDocumentHead(
      "Infopaket anfordern - kostenlos",
      "Infopaket anfordern"
    );
  });
  watch(
    () => antragfragen.value,
    (currentValue) => {
      if (!currentValue || currentValue.length === 0) {
        return;
      }
      const allFalse = currentValue.every((frage) => !frage.showFrageError);
      if (antragButtonClicked.value) {
        showErrorHinweis.value = !allFalse;
      }
    },
    { deep: true }
  );
  watch(
    () => route.params.token,
    () => {
      componentKeyStatus.value = componentKeyStatus.value + 1;
    },
    { immediate: true }
  );
</script>

<style scoped>
  .angebot-view {
    max-width: 1180px;
    margin: 0 auto;
    padding: 16px;
  }
  .angebot-grid {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 280px;
    gap: 20px;
    align-items: start;
  }
  .angebot-main {
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 14px;
  }
  .angebot-aside {
    position: sticky;
    top: 80px;
  }

  .ang-alert :deep(.v-alert__prepend),
  .ang-alert :deep(.v-alert__content) {
    font-size: 13.5px;
  }
  .ang-alert :deep(.v-alert) {
    border-radius: 3px !important;
  }

  .ang-submit {
    margin-top: 6px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .ang-submit__btn {
    height: 52px !important;
    font-weight: 700;
    letter-spacing: 0.4px;
    text-transform: none;
    border-radius: 3px !important;
    font-size: 16px;
    color: #ffffff !important;
  }
  .ang-submit__loading {
    display: flex;
    align-items: center;
    gap: 14px;
    background: #f7f9fc;
    border: 1px solid #e5e9f0;
    border-radius: 3px;
    padding: 14px 16px;
  }
  .ang-submit__loading-text {
    font-size: 16px;
    font-weight: 600;
    color: #0f4c81;
    margin: 0;
  }

  @media (max-width: 960px) {
    .angebot-view {
      padding: 12px;
    }
    .angebot-grid {
      grid-template-columns: 1fr;
      gap: 12px;
    }
  }
</style>
